import { Injectable } from '@angular/core';

@Injectable()
export class DateHelperService {
  constructor() {}

  public sameDate(date1: Date, date2: Date): boolean {
    let result = false;

    try {
      const day1 = date1.getDate();
      const day2 = date2.getDate();
      const month1 = date1.getMonth();
      const month2 = date2.getMonth();
      const year1 = date1.getFullYear();
      const year2 = date2.getFullYear();

      if (day1 === day2 && month1 === month2 && year1 === year2) {
        result = true;
      }
    } catch (err) {
      return undefined;
    }

    return result;
  }

  public getUtcDate(): Date {
    const date = new Date();

    const utcDate = new Date(
      Date.UTC(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        0,
        0,
        0
      )
    );

    return utcDate;
  }

  public getUtcDateTime(): Date {
    const date = new Date();

    const utcDate = new Date(
      Date.UTC(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds()
      )
    );

    return utcDate;
  }

  public getUtcDateFromDate(date: Date): Date {
    const utcDate = new Date(
      Date.UTC(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        0,
        0,
        0
      )
    );

    return utcDate;
  }

  public getUtcDateTimeFromDate(date: Date): Date {
    const now_utc = Date.UTC(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate(),
      date.getUTCHours(),
      date.getUTCMinutes(),
      date.getUTCSeconds()
    );
    return new Date(now_utc);
  }
}
